import React, { useState } from 'react';
import { auth, analytics } from './firebase';
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
} from 'firebase/auth';
import { logEvent } from 'firebase/analytics';

function Auth({ onAuthSuccess }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [isLogin, setIsLogin] = useState(true);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    try {
      if (isLogin) {
        await signInWithEmailAndPassword(auth, email, password);
        logEvent(analytics, 'login', {
          method: 'email',
          email,
        });
      } else {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        await updateProfile(userCredential.user, {
          displayName: fullName,
        });
        logEvent(analytics, 'sign_up', {
          method: 'email',
          email,
        });
      }
      onAuthSuccess();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="form-container">
      <h2 style={{ fontSize: '1.5rem', marginBottom: '10px' }}>
        <span role="img" aria-label="rocket">🚀</span> Join Supply Chain AI
      </h2>
      <p style={{ fontSize: '0.95rem', marginBottom: '15px', color: '#444' }}>
        Unlock instant demand forecasting & early access benefits.
      </p>
      <p style={{ fontSize: '0.85rem', marginBottom: '20px', color: '#666' }}>
        <span role="img" aria-label="lock">🔒</span> No spam. No payment required. Just sign in and explore!
      </p>

      {error && <p className="error-message">{error}</p>}

      <form onSubmit={handleSubmit}>
        {!isLogin && (
          <input
            type="text"
            placeholder="Your Full Name"
            value={fullName}
            onChange={e => setFullName(e.target.value)}
            required
          />
        )}
        <input
          type="email"
          placeholder="Your Email Address"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Your Password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />

        <button type="submit" style={{ marginTop: "10px", width: "100%" }}>
          {isLogin ? 'Continue with Email' : 'Create My Account'}
        </button>
      </form>

      <p style={{ fontSize: "14px", marginTop: "15px", color: "#444" }}>
        {isLogin ? "New here?" : 'Already have an account?'}{' '}
        <span
          onClick={() => setIsLogin(!isLogin)}
          style={{
            color: '#007bff',
            cursor: 'pointer',
            textDecoration: 'underline',
            fontWeight: 'bold'
          }}
        >
          {isLogin ? 'Create a free account' : 'Login here'}
        </span>
      </p>
    </div>
  );
}

export default Auth; // this is last line 
